import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Popover, Modal } from "antd";
import { Button } from "./ui/Button";
import logo from "../assets/img/logo.png";
import logoBrive from "../assets/img/logobrive.png";
import logoToulouse from "../assets/img/logotoulouse.png";
import { motion } from "framer-motion";
import { AndroidOutlined, AppleOutlined } from "@ant-design/icons";

export function Navbar({ transparent = false }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tick, setTick] = useState(0);
  const showCandidateModal = () => {
    setOpen(false);
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Le contenu du popover
  const popContent = (
    <div className="flex flex-col capitalize text-base space-y-3">
      <p
        onClick={showCandidateModal}
        className="hover:bg-gray-200 flex items-center p-1 hover:cursor-pointer"
      >
        Je suis candidat
      </p>
      <p
        onClick={() => {
          setOpen(false);
          window.location.href = "https://client.jm-interim.com/login";
        }}
        className="hover:bg-gray-200 flex items-center p-1 hover:cursor-pointer"
      >
        Je suis client
      </p>
      <p
        onClick={() => {
          setOpen(false);
          window.location.href = "https://freelance.jm-interim.com/login";
        }}
        className="hover:bg-gray-200 flex items-center p-1 hover:cursor-pointer"
      >
        Je suis recruteur
      </p>
    </div>
  );

  return (
    <header
      className={`w-full z-50 ${
        transparent ? "absolute top-0 left-0" : "bg-white shadow-sm"
      }`}
    >
      <div className="container mx-auto px-4 py-1">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/">
            <div className="w-24  h-24 overflow-hidden">
              {" "}
              {/* Conteneur avec taille fixe */}
              <motion.img
                key={logo}
                src={logo}
                className="w-full h-full object-contain"
                animate={{ rotate: 360 }} // Applique la rotation de 360°
                transition={{ duration: 2, ease: "easeOut" }} // Durée de l'animation
              />
            </div>
          </Link>
          {/* Navigation links (desktop) */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/offres-emploi"
              className="text-gray-700 hover:text-blue-600 font-medium"
            >
              Offres d'emploi
            </Link>
            <Link
              to="/devenir-interimaire"
              className="text-gray-700 hover:text-blue-600 font-medium"
            >
              Devenir intérimaire
            </Link>
            <Link
              to="/devenir-client"
              className="text-gray-700 hover:text-blue-600 font-medium"
            >
              Devenir client
            </Link>
            <Link
              to="/partenaire"
              className="text-gray-700 hover:text-blue-600 font-medium"
            >
              Devenir recruteur
            </Link>
            <Link
              to="/a-propos"
              className="text-gray-700 hover:text-blue-600 font-medium"
            >
              À propos et nos agences
            </Link>
            <Link
              to="/contact"
              className="text-gray-700 hover:text-blue-600 font-medium"
            >
              Contact
            </Link>
          </nav>

          <div className="flex items-center space-x-4">
            <Popover
              className="flex items-start"
              placement="bottom"
              content={popContent}
              trigger="click"
              open={open}
              onOpenChange={setOpen}
            >
              <Button variant="outline" className="hidden md:inline-flex">
                Se connecter
              </Button>
            </Popover>
            <Modal
              title="Accès Intérimaires"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              width={480}
            >
              <p className="mb-6 text-gray-700">
                Pour accéder à votre espace personnel, téléchargez l’application
                mobile « Mon Intérim » :
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://play.google.com/store/search?q=mon+interim&c=apps&hl=fr"
                  download
                  className="w-full"
                >
                  <Button
                    variant="primary"
                    className="w-full flex items-center justify-center space-x-2 py-3"
                  >
                    <AndroidOutlined className="h-5 w-5" />
                    <span>Télécharger pour Android</span>
                  </Button>
                </a>

                <a
                  href="https://apps.apple.com/us/app/mon-interim/id6480035958"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full"
                >
                  <Button
                    variant="secondary"
                    className="w-full flex items-center justify-center space-x-2 py-3"
                  >
                    <AppleOutlined className="h-5 w-5" />
                    <span>Télécharger pour iOS</span>
                  </Button>
                </a>
              </div>

              <div className="mt-6 text-left">
                <div className="mt-6 text-left">
                  <Button
                    className="bg-blue-600 text-white hover:bg-blue-700"
                    onClick={handleCancel}
                  >
                    Fermer
                  </Button>
                </div>
              </div>
            </Modal>

            <button className="md:hidden text-gray-700 hover:text-blue-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
